import { ModelRow } from "@mcleod/core";

export class LayoutMetadata {
    private readonly _baseVersion: boolean;
    private readonly _createDateTime: Date;
    private readonly _descr: string;
    private readonly _id: string;
    private readonly _isActive: string;
    private readonly _updateDateTime: Date;

    constructor(layoutRow: ModelRow) {
        if (layoutRow != null) {
            this._id = layoutRow.getString("id");
            this._baseVersion = layoutRow.getBoolean("base_version");
            this._createDateTime = layoutRow.getDateTime("create_datetime");
            this._descr = this._id === "base" ? "Base" : layoutRow.getString("descr", null);
            this._isActive = layoutRow.getString("is_active");
            this._updateDateTime = layoutRow.getDateTime("update_datetime");
        }
    }

    public get baseVersion(): boolean {
        return this._baseVersion;
    }

    public get createDateTime(): Date {
        return this._createDateTime;
    }

    public get descr(): string {
        return this._descr;
    }

    public get id(): string {
        return this._id;
    }

    public get isActive(): string {
        return this._isActive;
    }

    public get updateDateTime(): Date {
        return this._updateDateTime;
    }
}
